<template>
    <div
        :class="{
            'money-input': true,
            'el-input': true,
            'is-disabled': disabled,
            'el-input--small': size == 'small',
            'align-right': align === 'right',
            'align-center': align === 'center',
            'el-input-group': prepend !== null,
            'el-input-group--prepend': prepend !== null,
            'has-suffix': suffix !== null
        }"
    >
        <span class="el-input-group__prepend" v-if="prepend">{{ prepend }}</span>
        <input
            ref="input"
            key="input"
            :value="formatValue"
            :disabled="disabled"
            class="el-input__inner disabled"
            :placeholder="placeholder"
            @input="updateValue($event.target.value)"
            @blur="onBlur"
            @focus="selectAll"
            @change="onChange"
            @keyup="onKeyup"
            @click="onClick"
        />
        <span v-if="suffix" class="suffix">{{ suffix }}</span>
    </div>
</template>
<script>
import accounting from 'accounting-js';

export default {
    name: 'money-input',
    props: {
        updateOnKeyUp: {
            type: Boolean,
            default: true,
        },
        value: {
            type: [String, Number],
            default: 0,
            desc: '數值',
        },
        symbol: {
            type: String,
            default: '',
            desc: '幣別',
        },
        precision: {
            type: Number,
            default: 0,
            desc: '小數點位數',
        },
        prepend: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
            desc: '是否禁用',
        },
        size: {
            type: String,
            default: 'medium', // medium, small, mini
            desc: '大小',
        },
        align: {
            type: String,
            default: 'left',
        },
        allowNegative: {
            type: Boolean,
            default: false,
        },
        minimum: {
            type: [String, Number],
            default: null,
        },
        maximum: {
            type: [String, Number],
            default: null,
        },
        isSearch: Boolean,
        suffix: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            accounting,
            focused: false,
        };
    },
    computed: {
        formatValue() {
            if (this.isSearch && !this.value) return null;

            if (this.focused) {
                return this.value === '-' ? '-' : accounting.unformat(this.value);
            }
            return accounting.formatMoney(this.value, {
                symbol: this.symbol,
                precision: this.precision,
            });
        },
    },
    methods: {
        onClick() {
            if (this.focused) return;

            this.$nextTick(() => {
                this.$refs.input.focus();
            });
        },
        updateValue(value) {
            if (!this.checkInputValidate(value)) this.$refs.input.value = this.formatValue;

            let formatValue = value === '-' ? '-' : accounting.unformat(value);
            if (!this.allowNegative && formatValue < 0) {
                formatValue = -formatValue;
            }
            this.$emit('input', formatValue);
        },
        onBlur() {
            this.focused = false;
            if (this.isSearch && !this.value) this.$emit('input', null);
            else {
                this.$emit(
                    'input',
                    accounting.unformat(
                        accounting.formatMoney(this.value, {
                            precision: this.precision,
                        }),
                    ),
                );
            }

            this.onCheckRange();
            this.onChange();
            this.$emit('blur');
            this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
        },
        onCheckRange() {
            if (this.maximum !== null && this.value > this.maximum) {
                this.$emit('input', accounting.unformat(this.maximum));
            }
            if (this.minimum !== null && this.value < this.minimum) {
                this.$emit('input', accounting.unformat(this.minimum));
            }
        },
        onChange() {
            this.$emit('change');
        },
        onKeyup() {
            if (this.updateOnKeyUp) this.onChange();
        },
        selectAll(event) {
            this.focused = true;
            this.$nextTick(() => {
                event.target.select();
            });
        },
        dispatch(componentName, eventName, params) {
            let parent = this.$parent || this.$root;
            let name = parent.$options.componentName;
            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent;
                if (parent) {
                    name = parent.$options.componentName;
                }
            }
            if (parent) {
                // eslint-disable-next-line prefer-spread
                parent.$emit.apply(parent, [eventName].concat(params));
            }
        },
        checkInputValidate(value) {
            const letterList = value.split('');
            let isValid = true;
            letterList.forEach((letter) => {
                if (!this.matchType(letter)) {
                    this.shake();
                    isValid = false;
                }
            });
            return isValid;
        },
        matchType(input) {
            if (!input) return false;

            const inputNumberFormat = Number(input);
            const ASCII = Number(input.codePointAt(0));
            const validCharList = [45, 46];

            const isNumber = !Number.isNaN(inputNumberFormat);

            if (isNumber || validCharList.includes(ASCII)) return true;
            return false;
        },
        shake() {
            if (this.isPaste) return;

            this.$refs.input.classList.add('shake');
            this.$refs.input.classList.add('shake-constant');
            setTimeout(() => {
                this.$refs.input.classList.remove('shake');
                this.$refs.input.classList.remove('shake-constant');
            }, 150);
        },
        focus() {
            this.$refs.input.focus();
        },
    },
};
</script>
<style lang="scss">
.money-input {
    position: relative;

    &.align-right input {
        text-align: right;
    }
    &.align-center input {
        text-align: center;
    }
    &.has-suffix {
        .el-input__inner {
            padding-right: 50px;
        }
        > .suffix {
            position: absolute;
            top: 0;
            right: 15px;
            color: #999;
            font-size: 9pt;
            line-height: 40px;
        }
    }
    &.has-suffix.el-input--small {
        > .suffix {
            line-height: 32px;
        }
    }
}
</style>
